<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>
      <v-flex md12>
        <div>
          <material-card>
            <ValidationObserver ref="form" v-slot="{ passes }">
              <v-form @submit.prevent="passes(save)">
                <v-card>
                  <v-card-text>
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-flex xs12 sm6 md6 v-for="model in vModel" :key="model.key">
                          <ValidationProvider
                            :name="getLabel(model.key)"
                            rules="required"
                            v-slot="{ errors }"
                          >
                            <template v-if="model.key=='CompanyLogo'">
                              <v-flex xs12>
                                <v-btn color="info" type="button" @click="logoPicked">
                                  <v-icon>cloud_upload</v-icon>Logo
                                </v-btn>
                                <input
                                  type="file"
                                  style="display: none"
                                  id="CompanyLogo"
                                  accept="image/*"
                                  @change="onLogoPicked"
                                />
                                <input type="hidden" v-model="model.value" />
                                <span class="text-danger">{{ errors[0] }}</span>
                              </v-flex>
                              <v-flex xs12>
                                <img :src="getpreviewimage(model.value)" style="width:100%" v-if="model.value" />
                              </v-flex>
                            </template>
                            <v-text-field
                              v-else
                              v-model="model.value"
                              :label="getLabel(model.key)"
                              :error-messages="errors[0]"
                            />
                          </ValidationProvider>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn color="blue darken-1" text type="submit">{{$t('language.save')}}</v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </ValidationObserver>
          </material-card>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
import Base from "../../../shared/Base.vue";
import commonservice from "../../../shared/common.service";
export default {
  name: "companyview",
  extends: Base,
  created() {
    this.vModel = [];
    this.url = "client/setup/companies";
  },
  beforeRouteEnter(to, from, next) {
    axios.get("client/setup/companies").then(response => {
      next(p => {
        p.vModel = response.data;
        p.isEdit = true;
      });
    });
  },
  methods: {
    getLabel(key) {
      return this.$t("language." + key.toLowerCase().replace("company", ""));
    },
    logoPicked() {
      document.getElementById("CompanyLogo").click();
    },
    onLogoPicked(event) {
      if (commonservice.validFileSize(event.target.files[0])) {
        var reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        var self = this;
        reader.onload = function() {
          self.vModel = self.vModel.map(function(item) {
            if (item.key == "CompanyLogo") item.value = reader.result;
            return item;
          });
        };
      }
    },
    getpreviewimage(value){
      var matches = value.match(/^data:([A-Za-z-+\/]+);base64,(.+)$/);
      if (matches == null || matches.length !== 3) {
          return process.env.VUE_APP_API_URL.replace("/api/","") + value;
      }
      return value;
    }
  }
};
</script>